import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PhdesignFilterCriteria from './PhdesignFilterCriteria'
import PhdesignList from './PhdesignList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PhdesignAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPhdesignDashboardPhdesignList } from '../../store/slice/PharmaSlice';

export default function PhdesignListView({setShowEdit,setPhdesignId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.phdesignDashboard);   

    const [filteredPhdesignList, setFilteredPhdesignList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { phdesignDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (phdesignDashboard.phdesignList.length>-1){
        setFilteredPhdesignList(phdesignDashboard.phdesignList);
        transformToCardFormat(phdesignDashboard.phdesignList, setCardList);
      }
    },[phdesignDashboard.phdesignList])

    useEffect(()=>{
          transformToCardFormat(filteredPhdesignList, setCardList);
      },[filteredPhdesignList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredPhdesignList(phdesignDashboard.phdesignList);
            transformToCardFormat(phdesignDashboard.phdesignList, setCardList);

        } else {
            setFilteredPhdesignList(
                phdesignDashboard.phdesignList
                    .filter(phdesign=> phdesign.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(phdesignDashboard.filteredPhdesignList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PhdesignList
                    setShowEdit={setShowEdit}
                    setPhdesignId = {setPhdesignId}
                    tableList={filteredPhdesignList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}